module.exports = __webpack_public_path__ + "img/IMG_2076 (1).dbe7fffc.png";